// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import SpinnerSvg from '@rsuite/icon-font/lib/legacy/Spinner';
var Spinner = createSvgIcon({
    as: SpinnerSvg,
    ariaLabel: 'spinner',
    category: 'legacy',
    displayName: 'Spinner'
});
export default Spinner;
